import React, { Component } from 'react';
import { Trans } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios, { post } from 'axios';
import Cookies from 'universal-cookie';
import Loader from 'react-loader-spinner';
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider,KeyboardDatePicker } from "@material-ui/pickers"; 
import InlineDatePickerDemo from "../banner/InlineDatePickerDemo"
import ls from "local-storage"; 
import { options } from "../../config/options";
//import DatePicker from 'react-date-picker'; 
import * as ReactDom from 'react-dom'; 
import Select from 'react-select';


class BannerAdd extends Component { 
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
        this.onChangeCountry = this.onChangeCountry.bind(this);
        this.onChangeGender = this.onChangeGender.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeLink = this.onChangeLink.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onSavebanner = this.onSavebanner.bind(this);
        
        this.mystyle= { display: "none" };
        
        this.state = {
            maxDate: "",
            file: require("../../assets/img/cap1.png"),
            valuestartDate: null,
            valueendDate: null,
            errors:'',
            //minDate: new Date(),
            //minendDate:new Date(),
            disableIcon: null, 
            isDisable : false, 
            bannerperprice:0,image: '',
            closeCalendar: true,        
            items: [],
            currency:'',
            bannerlink:'',
            country_err:'',
            startdate_err:'',
            enddate_err:'',
            uploadimg:'',
            gender_err:'',
            banner_err:'',
            errorMsg:'',
            totalprice:0,
            image_name:'',
            minimum_days_for_ad:0,
            image_url:'',
            peopleforid: '',api_url:localStorage.getItem('api_url'),
            country:[],
            countryid:'',
            genderid:0,
            bannerdays:0,
            image_err:'',
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            user_id:JSON.parse(localStorage.getItem('session_userid')),

        }
        
    }
      
    componentDidMount(){

         this.setState({
            loader:'loder-icon'
            });
            setTimeout(() => {
                this.setState({
                    profilespace: '',
                    loader: 'none'
                });
              }, 300);


        var datalist = new FormData();   
          datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
          datalist.set('language', this.state.langKey); 
          
          axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
              }).then(res => {

                if(res.data.status === 'true') {
                    this.setState({
                        currency: res.data.result.currency,
                        bannerperprice:res.data.result.bannerprice
                    });
                } else {
                    this.props.history.push("/login");   
                }


            });
       
        axios.get(this.state.api_url+`admindatas`)
        .then(res => {
           
            const datas = res.data.result;           
            const country_raw = res.data.result.country;
            var country = [];
            country_raw && country_raw.map((i,k)=>{
                // console.log('k ~ '+i.id);
                var country_each_index = {};
                country_each_index.value = i.id;
                country_each_index.label = i.name+' - '+i.currencycode;
                country.push(country_each_index);
            })

            var d = new Date();
            const days = res.data.result.bannerdays;           
            d.setDate(d.getDate() + days);            
            //var minendDate = d.toISOString().slice(0, 10);            
            this.setState({
                minendDate:d,
                minDate:d,
                minimum_days_for_ad:res.data.result.minimum_days_for_ad,
            }); 
            
            this.setState({
                country,
                bannerdays:res.data.result.bannerdays,
                });

        })          
    
      }

      onSubmit(e) { 

        e.preventDefault();
        var err = 0;

                if(this.state.image === ''){
                          this.setState({
                            image_err : 'Kindly select Banner Image',
                        });
                          err++;
                 }
                 else {           
                        this.setState({
                            image_err : '',
                        });
                }

                if (!this.state.countryid ) {            
                           this.setState({
                            country_err : 'Kindly select country',
                        });
                           err++;
                 }
                 else {           
                        this.setState({
                            country_err : '',
                        });
                }

                if (!this.state.valuestartDate ) {            
                           this.setState({
                            startdate_err : 'Kindly select start date',
                        });
                           err++;
                 }
                 else {           
                        this.setState({
                            startdate_err : '',
                        });
                }

                if (!this.state.valueendDate ) {            
                           this.setState({
                            enddate_err : 'Kindly select end date',
                        });
                           err++;
                 }
                 else {           
                        this.setState({
                            enddate_err : '',
                        });
                }

                if (!this.state.bannerlink ) {            
                           this.setState({
                            banner_err : 'Kindly fill the banner link',
                        });
                           err++;
                 }
                 else if (this.state.bannerlink ) {  

                  var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                var str = this.state.bannerlink;
                //console.log(str.substring(0,4));
                var prot = str.substring(0,8);               
                var prot1 = str.substring(0,7);
                
                            if (!regexp.test(this.state.bannerlink)) {
                                       this.setState({
                                        banner_err : 'Please enter valid url.',
                                    });
                                       err++;
                                }
                            else if((prot != 'https://') && (prot1 != 'http://' )){
                                   
                                     this.setState({
                                        banner_err : 'Please enter the link with ',
                                    });
                                     err++;
                                }
                                /*else if(str.substring(0,8) != 'http://'){
                                     this.setState({
                                        banner_err : 'Please enter valid url.',
                                    });
                                }*/

                                else {           
                                    this.setState({
                                        banner_err : '',
                                    });
                            }
                 }
                 else {           
                        this.setState({
                            banner_err : '',
                        });
                }

                if (!this.state.genderid ) {            
                           this.setState({
                            gender_err : 'Kindly select gender',
                        });
                           err++;
                 }
                 else {           
                        this.setState({
                            gender_err : '',
                        });
                }

                 if(err == 0){

                    this.onSavebanner();
                }


        }

        closeModal(tabId) {
        this.setState({ 
            [tabId]: false
        });

       
    }

        onSavebanner(){

            this.setState({                                        
                errors: '',
                loader:'loder-icon'
                                                       
        });

                const url = this.state.api_url+'bannersaveweb';
                const formData = {
                    file: this.state.image,
                    user_id: this.state.user_id,
                    link:this.state.bannerlink,
                    startdate:this.state.valuestartDate,
                    enddate:this.state.valueendDate,
                    countryid:this.state.countryid,
                    genderid:this.state.genderid,
                    totalcost:this.state.totalprice,
                    currency:this.state.currency,}

            return  post(url, formData)
                .then(res => {                      
                        if(res.data.status === 'true'){
                            
                               //alert('saved');

                               this.props.history.push("/app/Banner"); 
      
                                } else {
                                    //alert(res.data.message);
                                    this.setState({                                        
                                        errors: res.data.message,
                                        errorMsg:'errorMsg',
                                        loader: 'none'
                                       
                                        });
                                        setTimeout(() => {
                                                this.setState({
                                                        errorMsg: 'errorMsghide'
                                                });
                                            }, 5000);
                                    
                                }
                  
                })

        }
    
        
       onChangeCountry(e){ 
            // console.log(e);
            this.setState({
                countryid:e.value,
            });
        }

        onChangeLink(e){
        this.setState({
            bannerlink:e.target.value,            
        });
        } 

        onChangeGender(e){ 
            // console.log(e);
            this.setState({
                genderid:e.value,
            });
        }   

        /*handleEnddateChange = date => { 
                this.setState({
                    valuestartDate: date 
                });
        
            var d = new Date(date);
            const days = this.state.bannerdays;           
            d.setDate(d.getDate() + days);
            //var minendDate = d.toISOString().slice(0, 10);            
            this.setState({
                minendDate:d,
                //valueendDate:d
            });          
            
        
        };*/


        handleEnddateChange = date => { 
                this.setState({
                    valuestartDate: date 
                });
        
            var d = new Date(date);  
            const days = this.state.minimum_days_for_ad;           
            d.setDate(d.getDate() + days); 

            this.setState({
                minendDate:d,
                //valueendDate:d
            });          
            
        
        };

         handleDateChange = date => { 

         if(this.state.valuestartDate){
                this.setState({
                    valueendDate: date 
                });
            var startdate = this.state.valuestartDate;  
            var enddate = date;   
            var perprice = this.state.bannerperprice;
            const oneDay = 24 * 60 * 60 * 1000; 
            const totaldayss = Math.round(Math.abs((startdate - enddate) / oneDay));
            const totaldays = totaldayss + 1;
            //alert('date ' + startdate + 'start' +  enddate + 'end ' + perprice);
            //alert(diffDays);
            var totalprice = totaldays * perprice; 
             this.setState({
                    totalprice: totalprice.toFixed(2)
                });   
            }
             else{

                this.setState({
                    message: 'Kindly select Start date then you can select End date'
                });
                this.setState({
                    modal4: true
                });

               // alert('select start date first');
            } 
        };




    onChange(e) {
   
    if(e.target.files[0]){
            this.setState({
              file: URL.createObjectURL(e.target.files[0])
            })
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            //console.log(files[0])
            this.createImage(files[0]);

        }
      }

     createImage(file) {
        
        let reader = new FileReader(); 
        var file_err = 0;
        var err = 0;

         //reader.readAsDataURL(file); 

          /* reader.onload = function (e) {
                var image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    var height = this.height;//alert(height);
                    var width = this.width;//alert(width);
                    console.log(this);
                    if ((height != 400 || height != 400) && (width != 1920 || width != 1920)) {
                        file_err++;
                        alert('Height and Width must not exceed 1920*400.');
                        err++;
                    }
                    else{
                        file_err=0;
                    alert('ok');
                    
                    }
                };
            }*/
        reader.onload = (e) => {
          this.setState({
            image: e.target.result,
            uploadimg: e.target.result,
          })


                var image = new Image();
                image.src = e.target.result;
                const scope = this;
                image.onload = function () {
                    var height = this.height;//alert(height);
                    var width = this.width;//alert(width);
                    
                     if ((height != 844 || height != 844) && (width != 400 || width != 400)) {
                        file_err++;                        
                        //alert('Height and Width must not exceed 1920*400.');                        
                        err++;
                        scope.setState({
                            image_err : 'Width and Height must not exceed 844*400.',
                            image:'',
                            uploadimg:'',
                        });

                    }
                    else{
                        file_err=0;  
                        scope.setState({
                            image_err : '',
                            
                        });

                    }

            };

           
          //this.onFormSubmit();
        };
        reader.readAsDataURL(file);
        
      }

      onFormSubmit(e){
        //e.preventDefault() 
        this.fileUpload(this.state.image);
      }

      fileUpload(image){
        alert(this.state.image);

         let errors = {};

         if((this.state.image === null) || (this.state.image === "")) {
            
          errors["uploadimage"] = "Please Select the banner Image";
                    this.setState({
                        errors: errors,
                        errorMsg:'errorMsg'
                        });
                       
        }

        else {


        const url = this.state.api_url+'uploadbannerimageweb';
        const formData = {file: this.state.image,user_id: this.state.user_id }
        
        console.log("sending data:"+JSON.stringify(formData));

        return  post(url, formData)
                .then(res => {
                        console.log("verify status ");console.log(res.data.status)
                        if(res.data.status === 'true'){
                            const image_url = res.data.imageurl;
                              const image_name = res.data.image_name;
                              errors["uploadimage"] = "";
                              errors["uploadimage_suc"] = "Image uploaded sucessfuly";
                              this.setState({
                                image_name: image_name,
                                image_url: image_url,
                                });
                                 this.setState({
                                    errors: errors,
                                    errorMsg:'errorMsg'
                                    });
                                      
                                localStorage.setItem('image_name', JSON.stringify(this.state.image_name));
                                localStorage.setItem('image_url', JSON.stringify(this.state.image_url));
                                
                                console.log("image_name"+this.state.image_name);
                                console.log("image_url"+this.state.image_url);
                               
      
                                } else {
                                    alert(res.data.message);
                                    errors["uploadimage"] = res.data.message;
                                    this.setState({
                                        file: require("../../assets/img/cap1.png"),
                                        errors: errors,
                                        errorMsg:'errorMsg'                                        
                                        });
                                        
                                }
                  
                })

              }

      }

      get_back = () => {
        //alert('yes');
        this.setState({            
            image:'',
            uploadimg:'',
            file:''
        });
    }


    render() {
      const { t } = this.props; 
        const { country } = this.state;

        const gender = [
             // { value: '0', label: 'Choose' },
              { value: '0', label: <Trans i18nKey="Male">Male</Trans> },
              { value: '1', label: <Trans i18nKey="Female">Female</Trans> }
        ]

         var style = {
            zIndex:10,
            backgroundColor:"white",
            position:"absolute",
            height:"80vh",
            width:"100%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            //width:"100%",
            overflowY:"hidden"
          };

        

        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>

              <div className={this.state.loader}>
                        <div style={style} id="loader">
                            <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                        </div>
                    </div>

             <form onSubmit={this.onSubmit} >
             <div className="rightSideContent">
        <div className="setting-page addsBanner">
          <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg">
            <div className="heading-left-top d-flex">
              <div className="align-self-center">
                <div className="iconHolder align-self-center mr-1">
                  <div className="backGlow d-block d-lg-none">
                    <div className="sideBarToggler sidebarIcoPos" />
                  </div>
                </div>
              </div> 
              <div className="align-self-center ">
                                    <NavLink to="/app/Banner">
                                        <div className="iconHolder align-self-center mr-1">
                                            <div className="backGlow">
                                                <div className="backIco"></div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>             
              <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Banner Advertise">Banner Advertise</Trans></span>
            </div>
            <div className="backGlow white-bg" />
          </div>
         
          {this.state.errors ?
              <div id="msgcolor" className={this.state.errorMsg}><Trans i18nKey={this.state.errors}>{this.state.errors}</Trans></div> : "" }
          <div className="settingsPageWidth">
            <div className="setFiltBox">
              <div className="mb-4">
              {this.state.langKey == 'ar' ? (
					 <div className="text-truncate bold-font BtoRcolor mb-2" style={{direction: "ltr"}}>
                <Trans i18nKey="Banner image for web (844 x 400) (only png,jpg,jpeg)">Banner image for web (844 x 400) (only png,jpg,jpeg)</Trans>
                </div>
													) :( <div className="text-truncate bold-font BtoRcolor mb-2">
                <Trans i18nKey="Banner image for web (844 x 400) (only png,jpg,jpeg)">Banner image for web (844 x 400) (only png,jpg,jpeg)</Trans>
                </div>)}
                <label className="img-upload" style={this.state.uploadimg ? {display: 'none'} : {  } } >
                  <input type='file' id='bannerimg' accept="image/png,image/gif,image/jpeg" onChange={this.onChange}/>
                  {/* Custom Upload */}               
                
                </label> 

                <label style={this.state.uploadimg ? {} : { display: 'none' } } >                                
                <img width = '100' height='110' id="img" src={this.state.uploadimg} alt="preview image" />
                 <button id="webbannerclose"  onClick={ ()=>{ this.get_back(); }  } type="button" class="close"><span aria-hidden="true">×</span></button>
                </label>            
              </div>
              <p className='WebcameAlert'><Trans i18nKey={this.state.image_err}>{this.state.image_err}</Trans></p>
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                <Trans i18nKey="Ads Banner link">Ads Banner link</Trans>
                </div>
                <input className id="bannerlink" placeholder="https://google.com/" value={this.state.bannerlink} onChange={this.onChangeLink}/>
              </div>
              {this.state.banner_err != '' &&
               <p className='WebcameAlert'>
                {
                  this.state.langKey == 'ar' ? <><span>https://</span><Trans i18nKey={this.state.banner_err}>{this.state.banner_err}</Trans></> : <><Trans i18nKey={this.state.banner_err}>{this.state.banner_err}</Trans><span>https://</span></>
                }
                
              </p>
              }
              <div className="mb-4">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="text-truncate BtoRcolor mb-2">
                    <Trans i18nKey="Start date">Start date</Trans>
                    </div>
                    
     

      {this.state.langKey == 'ar' ? 

      <KeyboardDatePicker
        autoOk
        variant="inline"       
        //format="dd/MM/yyyy"
        format="yyyy-MM-dd"
        value={this.state.valuestartDate}                                     
        minDate={this.state.minDate}
        InputAdornmentProps={{ position: "start" }}
        onChange={this.handleEnddateChange}
      />
        : 

         <KeyboardDatePicker
        autoOk
        variant="inline"       
        format="dd/MM/yyyy"
        //format="yyyy-MM-dd"
        value={this.state.valuestartDate}                                     
        minDate={this.state.minDate}
        InputAdornmentProps={{ position: "start" }}
        onChange={this.handleEnddateChange}
      />
    }


       

       
                     <p className='WebcameAlert'><Trans i18nKey={this.state.startdate_err}>{this.state.startdate_err}</Trans></p>
                  </div>

                   
                  <div className="col-12 col-sm-6">
                    <div className="text-truncate BtoRcolor mb-2"><Trans i18nKey="End date">End date</Trans></div>
                    {this.state.langKey == 'ar' ? 

                    <KeyboardDatePicker
                                        autoOk
                                        variant="inline" 
                                      onChange={this.handleDateChange}
                                      value={this.state.valueendDate}                                     
                                      minDate={this.state.minendDate}                                      
                                      format="yyyy-MM-dd"
                                      //format="dd/MM/yyyy"
                                      name="Enddate" 
                                      clearIcon={this.state.disableIcon}
                                      closeCalendar={this.state.closeCalendar} 
                                          
                                  />

                    :




                    <KeyboardDatePicker
                                        autoOk
                                        variant="inline" 
                                      onChange={this.handleDateChange}
                                      value={this.state.valueendDate}                                     
                                      minDate={this.state.minendDate}                                      
                                      //format="yyyy-MM-dd"
                                      format="dd/MM/yyyy"
                                      name="Enddate" 
                                      clearIcon={this.state.disableIcon}
                                      closeCalendar={this.state.closeCalendar} 
                                          
                                  />

                    }
                        <p className='WebcameAlert'><Trans i18nKey={this.state.enddate_err}>{this.state.enddate_err}</Trans></p>
                  </div>
                </div>
                
              </div>
              <div className="mb-4">
                <div className="row">
                  <div className="col-6">
                    <div className="text-truncate bold-font BtoRcolor mb-2">
                      <Trans i18nKey='Country'>Country</Trans>
                    </div>
                    <Select
                                            name="countryid"  
                                            id="bannercountry"                                            
                                            placeholder={<div><Trans i18nKey='Select Country'>Select Country</Trans></div>}
                                            value={country.find(item => item.value === this.state.countryid)}
                                            onChange={this.onChangeCountry}
                                            options={country}
                                        />
                        <p className='WebcameAlert'><Trans i18nKey={this.state.country_err}>{this.state.country_err}</Trans></p>
                  </div>

                   
                  <div className="col-6">
                    <div className="text-truncate bold-font BtoRcolor mb-2">
                      <Trans i18nKey='Gender'>Gender</Trans>
                    </div>
                   <Select
                                            placeholder={<div><Trans i18nKey='Choose your gender'>Choose your gender</Trans></div>}
                                            name="gender"
                                            id="bannercountry"
                                            onChange={this.onChangeGender}
                                            options={gender}
                                        />
                        <p className='WebcameAlert'><Trans i18nKey={this.state.gender_err}>{this.state.gender_err}</Trans></p>
                  </div>
                </div>

                  
              </div>
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="text-truncate bold-font BtoRcolor mb-2">
                    <Trans i18nKey="Per day price information">Per day price information</Trans>
                  </div>
                  <div className="price">{this.state.bannerperprice} {this.state.currency}</div>
                </div>
              </div>
              <div className="mb-5">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="text-truncate bold-font BtoRcolor mb-2">
                    <Trans i18nKey="total price amount">total price amount</Trans>
                  </div>
                  <div className="price">{this.state.totalprice} {this.state.currency}</div>
                </div>
              </div>
              <button className="btn-common add_wallet_btn w-100">
                <Trans i18nKey='Send Request'>Send Request</Trans>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <Modal isOpen={this.state.modal4} toggle={this.closeModal.bind(this, 'modal4')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal4')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal4')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>

         </form>     
         </MuiPickersUtilsProvider>         
            
        )
    }
}

export default withTranslation("translations")(BannerAdd);
